<template>
  <!--<div id="app">-->
  <v-app id="inspire">
    <Navigation />
    <router-view />
    <v-snackbar
      v-for="(message, index) in messages.slice().reverse()"
      :key="index"
      :absolute="false"
      :style="{ 'margin-bottom': (index*6)+'em'}"
      :timeout="-1"
      :value="true"
      :color="message.color">
      {{ message.text }}
      <template v-slot:action="{ attrs }">
        <v-btn
          icon
          color="normal"
          @click="removeMessage(message.id)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
    <v-overlay :value="loader">
      <v-progress-circular
        indeterminate
        size="64" />
    </v-overlay>
  </v-app>
  <!--</div>-->
</template>

<script>
import Navigation from '@/components/Navigation'
import {mapState} from 'vuex'

export default {
  name: 'App',
  components: {Navigation},
  data () {
    return {
      drawer: true
    }
  },
  computed:{
    ...mapState({
      loader: state => state.loader.loader,
      messages: state => state.alert.messages,
    })
  },
  methods: {
    removeMessage (id) {
      this.$store.commit("alert/deleteMessage", id)
    }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>



// WEBPACK FOOTER //
// src/App.vue